import { render, staticRenderFns } from "./MatchedGroupCard.vue?vue&type=template&id=a3ca72dc&scoped=true"
import script from "./MatchedGroupCard.vue?vue&type=script&lang=js"
export * from "./MatchedGroupCard.vue?vue&type=script&lang=js"
import style0 from "./MatchedGroupCard.vue?vue&type=style&index=0&id=a3ca72dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ca72dc",
  null
  
)

export default component.exports